
















import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import ShortcutsSection from './ShortcutsSection.vue';
import CoursesSection from './CoursesSection.vue';
import { CollapsableItem, LearnifierCourse } from '../../../models/CollapsableMenu';
import ContactsSection from './ContactsSection.vue';

@Component({
    components: {
        CoursesSection,
        ShortcutsSection,
        ContactsSection
    }
})
export default class CollapsableMenu extends Vue {
    private collapsableItems!: CollapsableItem[];
    isLoading: boolean = false;

    constructor() {
        super();
        this.collapsableItems = JSON.parse(this.$attrs['data-collapsable-items'] as string);
    }

    mounted() {
        this.getEducations();
    }

    private toggleItem(i: number) {
        const temp = [...this.collapsableItems];
        temp[i].isOpen = !this.collapsableItems[i].isOpen;
        this.collapsableItems = temp;
    }

    private getEducations() {
        this.isLoading = true;
        const requestContext = (window as any).__litium.requestContext;

        axios({
            method: 'get',
            url: `/api/everyday/learnifier/courses`,
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
            .then((response: any) => {
                this.isLoading = false;
                const learnifierCourses = response.data as LearnifierCourse[];

                if (this.collapsableItems.length > 0) {
                    this.collapsableItems[0].items = learnifierCourses.map((course: LearnifierCourse) => ({
                        title: course.userTitle,
                        subTitle: course.userDescription,
                        link: course.accessLink,
                        target: '_blank',
                        email: '',
                        phoneNumber: '',
                        date: '',
                        imageUrl: course.thumbnail,
                        duration: course.duration,
                        status: course.status,
                        deadline: course.endDate,
                        isCourse: true
                    }));
                }
            })
            .catch((response: any) => {
                this.isLoading = false;
                console.error(response);
            });
    }
}
